import { render, staticRenderFns } from "./OrgPickerConfig.vue?vue&type=template&id=83b309ac&scoped=true"
import script from "./OrgPickerConfig.vue?vue&type=script&lang=js"
export * from "./OrgPickerConfig.vue?vue&type=script&lang=js"
import style0 from "./OrgPickerConfig.vue?vue&type=style&index=0&id=83b309ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b309ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83b309ac')) {
      api.createRecord('83b309ac', component.options)
    } else {
      api.reload('83b309ac', component.options)
    }
    module.hot.accept("./OrgPickerConfig.vue?vue&type=template&id=83b309ac&scoped=true", function () {
      api.rerender('83b309ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/OrgPickerConfig.vue"
export default component.exports